import request from '@/sheep/request';

function normalizePageResult(response) {
  const pageData = response?.data || {};
  const list = Array.isArray(pageData.list) ? pageData.list.map(formatListItem) : [];
  return {
    list,
    total: Number(pageData.total || 0),
    pageNo: Number(pageData.pageNo || 1),
    pageSize: Number(pageData.pageSize || list.length || 0),
  };
}

function formatListItem(item = {}) {
  const typeValue = Number(item.type || 1);
  return {
    ...item,
    type: item.type,
    image: item.coverUrl || item.homeCoverUrl || '',
    price: item.price,
    salesText: formatSalesText(item.virtualServiceCount),
    subtitle: buildSubtitle(item, typeValue),
  };
}

function formatDetailItem(item = {}) {
  const typeValue = Number(item.type || 1);
  return {
    ...item,
    type: item.type,
    image: item.coverUrl || item.homeCoverUrl || '',
    price: item.price,
    salesText: formatSalesText(item.virtualServiceCount),
    subtitle: buildSubtitle(item, typeValue),
    description: buildDescription(item),
    detail: item.detail || '',
  };
}

function formatSalesText(count) {
  return `已有${Number(count || 0)}+次测评`;
}

function buildSubtitle(item, type) {
  if (Number(type) === 1) {
    const segments = [];
    if (item.questionCount) {
      segments.push(`${item.questionCount}题`);
    }
    if (item.estimatedDuration) {
      segments.push(`约${item.estimatedDuration}分钟`);
    }
    return segments.join(' · ') || item.subtitle || '';
  }

  if (Number(type) === 2) {
    const durationText = formatDuration(item.treatmentDuration || item.treatmentDurationValue, item.treatmentTimeUnit);
    return durationText || item.subtitle || '';
  }

  return item.subtitle || '';
}

function formatDuration(value, unit) {
  if (!value) {
    return '';
  }
  const unitMap = {
    1: '周',
    2: '月',
  };
  return `${value}${unitMap[unit] || ''}`;
}

function buildDescription(item) {
  const tags = parseServiceTags(item.serviceTags);
  if (tags.length > 0) {
    return tags.join(' · ');
  }
  return item.subtitle || '';
}

function parseServiceTags(serviceTags) {
  if (!serviceTags) {
    return [];
  }
  try {
    const parsed = JSON.parse(serviceTags);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (error) {
    return [];
  }
}

const ServiceListApi = {
  getServiceList: async (params) => {
    const response = await request({
      url: '/operation/product/page',
      method: 'GET',
      params: params,
      custom: {
        showLoading: false,
        showError: false,
      },
    });
    return normalizePageResult(response);
  },

  getServiceDetail: async (id) => {
    const response = await request({
      url: '/operation/product/get',
      method: 'GET',
      params: { id },
      custom: {
        showLoading: false,
        showError: false,
      },
    });
    const detail = response?.data;
    return detail ? formatDetailItem(detail) : null;
  },
  // 查询商品分类
  getListByParent: (params) => {
    return request({
      url: '/operation/product/category-with-products',
      method: 'GET',
      params,
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  getTop2: (params) => {
	  return request({
	    url: '/operation/product/top2',
	    method: 'GET',
	    params,
	    custom: {
	      showError: false,
	      showLoading: false,
	    },
	  });
  },
  getCategoryByType: (params) => {
  	  return request({
  	    url: '/operation/product/category-by-type',
  	    method: 'GET',
  	    params,
  	    custom: {
  	      showError: false,
  	      showLoading: false,
  	    },
  	  });
  }
};

export default ServiceListApi;
